"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ColorUtil =
/** @class */
function () {
  function ColorUtil() {}

  ColorUtil.getHexColorOrFillFromColorId = function (colorsApi, colorPalette, colorId) {
    if (colorPalette === void 0) {
      colorPalette = [];
    }

    var hexColor = ColorUtil.NoIdOrHexValue;

    if (colorId && colorId.length) {
      if (colorsApi.isCustomColor(colorId)) {
        hexColor = colorsApi.getHexColorFromClassName(colorId);
      } else {
        var paletteColor = ColorUtil._findPaletteFromColorId(colorPalette, colorId);

        if (paletteColor) {
          hexColor = paletteColor.hexValue;
        } else if (colorPalette.length > 0) {
          // Default to the last color in the palette if we didn't find the color that was set.  This						}
          // can happen when switching to a palette with less colors		
          hexColor = colorPalette[colorPalette.length - 1].hexValue;
        }
      }
    }

    return hexColor;
  };

  ColorUtil.getColorIdFromHexColor = function (colorsApi, colorPalette, hexColor) {
    if (colorPalette === void 0) {
      colorPalette = [];
    }

    var colorId = ColorUtil.NoIdOrHexValue;

    if (hexColor && hexColor.length) {
      var paletteColor = ColorUtil._findPaletteFromHexColor(colorPalette, hexColor);

      if (paletteColor) {
        colorId = paletteColor.name;
      } else {
        var customPalette = colorsApi.getCustomPaletteDefinition();
        var fills = customPalette['fills'];
        var ids_1 = customPalette['ids'];
        fills.find(function (fill, idx) {
          var matched = fill === hexColor;

          if (matched) {
            colorId = ids_1[idx];
          }

          return matched;
        });

        if (!colorId && colorPalette.length > 0) {
          // Default to the last color in the palette if we didn't find the color that was set.  This		
          // can happen when switching to a palette with less colors		
          colorId = colorPalette[colorPalette.length - 1].name;
        }
      }
    }

    return colorId;
  };

  ColorUtil.getColorStyle = function (color, backgroundColor, pattern) {
    var style = {};
    var backgroundStyle = [];

    if (color) {
      style.color = color;
    }

    if (backgroundColor) {
      backgroundStyle.push(backgroundColor);
    }

    if (pattern) {
      backgroundStyle.push("url('dashboard-core/images/patterns/" + pattern + ".svg')");
      style.backgroundRepeat = 'repeat';
      var textShadows = [[2, 2, 2], [2, -2, 2], [2, 0, 2], [-2, 2, 2], [-2, -2, 2], [-2, 0, 2], [0, 2, 2], [0, -2, 2], [0, 0, 2]];
      style['text-shadow'] = textShadows.map(function (shadow) {
        return shadow.join('px ') + "px #ffffff";
      }).join(',');
    }

    if (backgroundStyle.length > 0) {
      if (pattern) {
        style.background = backgroundStyle.join(' ');
      } else {
        style.backgroundColor = backgroundStyle[0];
      }
    }

    return style;
  };

  ColorUtil.getOrCreateColorIdFromHexColor = function (colorsApi, colorPalette, hexColor) {
    if (colorPalette === void 0) {
      colorPalette = [];
    }

    var paletteColor = ColorUtil._findPaletteFromHexColor(colorPalette, hexColor);

    if (!paletteColor) {
      paletteColor = ColorUtil._createCustomColor(colorsApi, hexColor);
    }

    return paletteColor ? paletteColor.name : undefined;
  };
  /**
   *
   * @param hexColor The hexColor string to convert from (eg #cda5ec)
   * @param alpha  The alpha (opacity) percentage. Values > 1 are converted to their fractional equivalent
   */


  ColorUtil.getRgbaColorFromHexColor = function (hexColor, alpha) {
    if (hexColor.startsWith('#')) {
      var colors = [];

      for (var i = 1; i < hexColor.length;) {
        colors.push(parseInt(hexColor.charAt(i++) + hexColor.charAt(i++), 16));
      }

      if (alpha > 1) {
        alpha = alpha / 100;
      }

      colors.push(alpha);
      return "rgba(" + colors.join(',') + ")";
    }

    return null;
  };

  ColorUtil._createCustomColor = function (colorsApi, hexColor) {
    var className = colorsApi.addCustomColor(hexColor);
    return colorsApi.createColorDefinition(className, hexColor, hexColor);
  };

  ColorUtil._findPaletteFromColorId = function (paletteColors, colorId) {
    return paletteColors.find(function (paletteColor) {
      return paletteColor['name'] === colorId;
    });
  };

  ColorUtil._findPaletteFromHexColor = function (paletteColors, hexColor) {
    return paletteColors.find(function (paletteColor) {
      var hexValue = paletteColor['hexValue'];
      return hexValue.pattern && hexValue.pattern === hexColor.pattern || hexValue === hexColor;
    });
  };

  ColorUtil.NoIdOrHexValue = ''; // Indicate 'No color' Id or 'No color' hex value

  return ColorUtil;
}();

exports.default = ColorUtil;
